import useBaseAPI from './useBaseAPI';

const useDashboardAPI = () => {
  const { client, isLoading } = useBaseAPI();

  const getApplication = async () => {
    try {
      const response = await client('get', '/dashboard/');
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  return {
    getApplication,
    isLoading,
  };
};

export default useDashboardAPI;
